// extracted by mini-css-extract-plugin
export default {"root":"RecentlyExploredArea_root__K9P6I","text":"RecentlyExploredArea_text__jIqlm"};